import {isNil} from 'ramda';

import type {Nullish} from 'shared/web';

import {calculateReportPercentage} from './calculateReportPercentage';

export function calculateReportDiscountPercent(
  discount: number | Nullish,
  revenue: number | Nullish
) {
  if (isNil(discount) || isNil(revenue)) {
    return null;
  }
  // Report revenue is after discount; restore the original price for the discount rate.
  return calculateReportPercentage(discount, revenue + discount);
}
